import {Fragment} from "react";
import {DatePicker} from "react-advance-jalaali-datepicker";

const DatePickerComponent = ({preSelected, handleChange, label}) => {

    return(
        <Fragment>
            <div className='datepicker-container'>
                <DatePicker cancelOnBackgroundClick format="jYYYY/jMM/jDD" placeholder='تاریخ' preSelected={preSelected} controlValue={true} inputTextAlign='center' onChange={handleChange} customClass='datepicker' />
                <i className="fa fa-calendar" aria-hidden="true"></i>
            </div>
            <span>{label}</span>
        </Fragment>
    )
}

export default DatePickerComponent